function init_girlnew(from_php){
    var main=$(".place.girlnew"),win,
    curTextObj={},curTextArr=[];
    
    var girlConfArr={
        "out":{
            "custom":{"eye":2,"mouth":3,"extra":2,"eye_interval":100,"extra_interval":100},
            "maggie":{"eye":1,"extra_interval":200,"eye_interval":200},
            "winona":{"eye":1,"extra":3,"eye_interval":200,"extra_interval":200},
            "anya":{"eye":0,"extra":2,"eye_interval":200,"extra_interval":200}
        },
        "in":{
            "custom":{"eye":2,"mouth":3,"extra":2,"eye_interval":100,"extra_interval":100},
            "cherry":{"eye":2,"mouth":3},
            "indira":{"eye":2,"mouth":2},
            "twins":{"eye":2,"mouth":2},
            "zoe":{"eye":2,"mouth":2},
            "maggie":{"extra_interval":200},
            "winona":{extra:1,"extra_interval":500},
            "anya":{"eye":2,"eye_interval":200},
            "linn":{extra:1,"extra_interval":1000}
        },
        "more":{
            "custom":{"eye":2,"mouth":3,"extra":2,"eye_interval":100,"extra_interval":100},
            "winona":{"extra_interval":500},
            "linn":{extra:1,"extra_interval":1000}
        }
        
    };
    var girlConf;
    
    
    
    var animIndex={
        eye:_moduleTimeHandler.getNewIndex(),
        mouth:_moduleTimeHandler.getNewIndex(),
        extra:_moduleTimeHandler.getNewIndex()
    };
    
    function calculateWordDimensions(text, classes) {
        classes = classes || [];


        classes.push('textDimensionCalculation');

        var div = document.createElement('div');
        div.setAttribute('class', classes.join(' '));

        $(div).text(text);

        main[0].appendChild(div);

        var dimensions = {
            width : $(div).outerWidth(),
            height : $(div).outerHeight()
        };

        div.parentNode.removeChild(div);

        return dimensions;
    };
    function getNextWholeText(textArrAll,init){
        if(textArrAll.length<1){
            if(win.is(".outJS")){
                showWindowIn();
                return false;
            }
            else if(win.is(".inJS")){
                showWindowMore();
                return false;
            }
            else{
                $.goToLocation("girls/"+from_php.girl_data.girl_id+"/");
                //go to girl
                return false;
            }
            
        }
        if(!init){
            _mySound.playSound("page_selector");
        }
        
        curTextObj=textArrAll.shift();
        win.find(".sayBoxJS").hide().filter("[data-type='"+curTextObj.type+"']").show();
        var textArr=curTextObj.text.split(" "),textTmp=[],i;
        var textObjField=win.find(".contentSayJS");
        var textHeight=textObjField.height();
        while(textArr.length>0){
            textTmp=[];
            for(i=0;i<10;i++){
                textTmp.push(textArr.shift());
            }
            while(textArr.length>0 && calculateWordDimensions(textTmp.join(" "),["textForSayClass"]).height<=textHeight){
                textTmp.push(textArr.shift());
            }
            if(calculateWordDimensions(textTmp.join(" "),["textForSayClass"]).height>textHeight){
                textArr.unshift(textTmp.pop());
            }
            curTextArr.push(textTmp.join(" "));
        }
        function nextStep(){
            textObjField.off("lBl_end,lBl_start").one("lBl_start",function(){
                if(curTextObj.type=="girl"){
                    prepareMouthAnim();
                }
            }).on("lBl_end",function(){
                _moduleTimeHandler.clear(animIndex["mouth"]);
            }).letterByletter({letterTime:40,text:curTextArr.shift()},_moduleTimeHandler);
            win.find(".sayBox").trigger("nextStep");
        }
        
        nextStep();
        win.find(".nextTextJS").off("click.nextGN").on("click.nextGN",function(){
            if(textObjField.letterByletter("isEnd")==1){
                if(curTextArr.length>0){
                    nextStep();
                    _mySound.playSound("page_selector");
                }
                else{
                    getNextWholeText(textArrAll);
                }
            }
            else{
                _mySound.playSound("page_selector");
                textObjField.letterByletter("clear");
            }
        });
    }
    function prepareMouthAnim(){
        var step=1,dir=1,step_max=girlConf["mouth"]
        ,obj=win.find(".girlParts .m");
        _moduleTimeHandler.clear(animIndex.mouth);
        _moduleTimeHandler.set(animIndex.mouth,function(){
            step+=dir;
            if(step==step_max){
                dir=-1;
            }
            if(step==1){
                dir=1;
            }
            obj.attr("data-step",step);
        },150,function(){
           obj.attr("data-step",0);
        });
    }
    function prepareEyeAnim(){
        _moduleTimeHandler.clear(animIndex.eye);
        function makeEyeAnim(){
            var step=0,dir=1,step_max=girlConf["eye"]
            ,obj=win.find(".girlParts .eye");
            _moduleTimeHandler.set(animIndex.eye,function(){
                step+=dir;
                if(step==step_max){
                    dir=-1;
                }
                obj.attr("data-step",step);
                if(step==0){
                    _moduleTimeHandler.clear(animIndex.eye);
                    _moduleTimeHandler.setOne(animIndex.eye,function(){
                        makeEyeAnim();
                    },mt_rand(1500,4500));
                }
            },girlConf.eye_interval);
            
            
        }
        if(girlConf["eye"]){
            _moduleTimeHandler.setOne(animIndex.eye,function(){
                makeEyeAnim();
            },mt_rand(400,1500));
        }
    }
    function prepareExtraAnim(){
        _moduleTimeHandler.clear(animIndex.extra);
        var step=0,dir=1,step_max=girlConf["extra"]
        ,obj=win.find(".girlParts .extra");
        _moduleTimeHandler.set(animIndex.extra,function(){
            step+=dir;
            if(step==step_max){
                dir=-1;
            }
            if(step<=0){
                dir=1;
                step=0;
            }
            obj.attr("data-step",step);
        },girlConf.extra_interval);
    }
    
    function prepareConf(mode){
        girlConf=copyObj(girlConfArr[mode]["custom"]);
        if(typeof girlConfArr[mode][from_php.girl_data.img]!="undefined"){
            girlConf=$.extend(girlConf,girlConfArr[mode][from_php.girl_data.img]);
        }
        _moduleEvents.trigger("showWindow",mode);
    }
    
    function showWindowOut(){
        prepareConf("out");
        
        _mySound.playSound("girl_smile");
        main.find(".win").hide();
        win=main.find(".win.outJS").show();
        getNextWholeText(from_php.dialog["out"],1);
        prepareEyeAnim();
        prepareExtraAnim();
    }
    
    function showWindowIn(){
        prepareConf("in");
        
        if(from_php.dialog["in"].length==0){
            $.goToLocation("girls/"+from_php.girl_data.girl_id+"/");
            return false;
        }
        _mySound.playSound("girl_smile");
        main.find(".win").hide();
        win=main.find(".win.inJS").show();
        getNextWholeText(from_php.dialog["in"]);
        
        prepareEyeAnim();
        prepareExtraAnim();
    }
    function showWindowMore(){
        prepareConf("more");
        
        if(from_php.dialog["more"].length==0){
            $.goToLocation("girls/"+from_php.girl_data.girl_id+"/");
            return false;
        }
        _mySound.playSound("girl_smile");
        main.find(".win").hide();
        win=main.find(".win.moreJS").show();
        getNextWholeText(from_php.dialog["more"]);
        
        prepareEyeAnim();
        prepareExtraAnim();
    }
    
    function test1(a,b,c){
        console.log(a);
        console.log(b);
        console.log(c);
    }
    if(from_php.qconf.own_js!=""){
//        init_girlnew_linn
        _moduleEvents.on("useFun",function(params){
            var funName=params[0];
            var arg =Array.prototype.slice.call(params,1),i;
            if (eval("typeof " + funName + " == 'function'")) {
                eval(funName).apply(window,arg);
            }
            
        });



        var fun_name="init_girlnew_"+from_php.qconf.own_js;
        if (eval("typeof " + fun_name + " == 'function'")) {
            var fn = window[fun_name];
            fn(from_php);
        }
        
    }
    else{
        showWindowOut();
    }
    
    
//    debugArr(calculateWordDimensions("jaspd fjasod fijpasdfjopaidjsfoa dosjf  dofijapsfj apsdfoj asoidfj pofdjs oiadjsf piojsfd oiajsdfoiajsdf opdsfj asfj pasdfj padfjs oaidfjs podjsf ",["textForSayClass"]));
    
//    debugArr(from_php.dialog.out);
    
}